export type SocialNetwork = 'facebook' | 'instagram';

export interface SocialProfile {
  network: SocialNetwork;
  /** The network's name, as it is read out after "Wanderlust Cravings on". */
  label: string;
  url: string;
}

/**
 * The business's own accounts. The site footer links to them and the home
 * page's structured data lists them as `sameAs`, so the two read from one
 * list and cannot disagree.
 */
export const SOCIAL_PROFILES: readonly SocialProfile[] = [
  { network: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/wanderlustcravings' },
  {
    network: 'instagram',
    label: 'Instagram',
    url: 'https://www.instagram.com/wanderlustcravingstravel/',
  },
];
